/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrowRight': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M49 24.996c-.02-.5-.229-1.08-.574-1.444l-11.294-11.9c-.766-.682-2.233-.963-3.088-.176-.844.777-.816 2.284.022 3.063l7.941 8.357H3.117A2.11 2.11 0 001 24.996c0 1.16.949 2.1 2.118 2.1h38.89l-7.942 8.358c-.722.719-.857 2.278-.022 3.062.833.785 2.355.534 3.088-.175l11.294-11.9A2.02 2.02 0 0049 24.996v-.001z" _fill="#4F8199" fill-rule="evenodd"/>'
  }
})
